import { upperCase } from 'lodash';

export const getTransactionStatusColor = (transactionStatus: string): string => {
  switch (upperCase(transactionStatus)) {
    case 'COMPLETED':
      return 'green';

    case 'CANCELED':
      return 'red';

    case 'PENDING':
      return 'yellow';

    default:
      return 'black';
  }
};
